import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatDuration } from "@air/utilities";
import { memo } from "react";
import { useResizeDetector } from "react-resize-detector";
export const VideoStandardTime = /*#__PURE__*/ memo((param)=>{
    let { currentTime, totalTime } = param;
    const { ref: resizeRef, width } = useResizeDetector({
        handleHeight: false
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-1 text-14 text-grey-11",
        "data-testid": "VIDEO_STANDARD_TIME",
        style: {
            fontFeatureSettings: "'tnum' on"
        },
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text-right font-medium text-grey-12",
                "data-testid": "VIDEO_STANDARD_TIME_CURRENT",
                style: {
                    minWidth: width
                },
                children: formatDuration(currentTime)
            }),
            /*#__PURE__*/ _jsx("span", {
                children: "/"
            }),
            /*#__PURE__*/ _jsx("span", {
                "data-testid": "VIDEO_STANDARD_TIME_TOTAL",
                ref: resizeRef,
                children: totalTime ? formatDuration(totalTime) : "-"
            })
        ]
    });
});
VideoStandardTime.displayName = "VideoStandardTime";
